  (() => {
    class ProductStickyForm extends HTMLElement {
      constructor() {
        super();
        
        this.mainAddToCartButton = document.getElementById('AddToCart');
        this.stickyAddToCartButton = document.getElementById('StickyAddToCart');
        
        if (this.mainAddToCartButton && this.stickyAddToCartButton) {
          // Create a separate clickable element
          this.clickableDiv = document.createElement('div');
          this.clickableDiv.style.cssText = `
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: transparent;
            cursor: pointer;
            z-index: 10;
            display: none;
          `;
          
          this.clickableDiv.addEventListener('click', (e) => {
            const productTitle = document.querySelector('.product-meta');
            if (productTitle) {
              productTitle.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          });
          
          // Add the clickable div to the sticky form element
          this.appendChild(this.clickableDiv);
          
          this.setupButtonSync();
        }
      }

      connectedCallback() {
        this._setupVisibilityObservers();
      }

      setupButtonSync() {
        // Create an observer to watch for changes to the main button
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
              // Sync disabled state
              if (this.mainAddToCartButton.hasAttribute('disabled')) {
                this.stickyAddToCartButton.setAttribute('disabled', '');
                this.stickyAddToCartButton.innerHTML = `
                  <span class="button__label-options">SELECT OPTIONS</span>
                  <span class="button__label-soldout" style="display: none;">SOLD OUT</span>
                  <span class="price price--sale">
                    <product-price class="empty-hide jsProductPrice">${this.mainAddToCartButton.querySelector('.jsProductPrice')?.innerHTML || ''}</product-price>
                  </span>
                `;
                this.stickyAddToCartButton.classList.add('button--ternary');
                this.stickyAddToCartButton.classList.add('variant--disabled');
                
                // Show the clickable div
                this.clickableDiv.style.display = 'block';
              } else {
                this.stickyAddToCartButton.removeAttribute('disabled');
                this.stickyAddToCartButton.innerHTML = `
                  <span class="button__label">ADD TO CART</span>
                  <span class="price price--sale">
                    <product-price class="empty-hide jsProductPrice">${this.mainAddToCartButton.querySelector('.jsProductPrice')?.innerHTML || ''}</product-price>
                  </span>
                `;
                this.stickyAddToCartButton.classList.remove('button--ternary');
                this.stickyAddToCartButton.classList.remove('variant--disabled');
                
                // Hide the clickable div
                this.clickableDiv.style.display = 'none';
              }
            }
          });
        });

        // Observe changes to the main button's attributes
        observer.observe(this.mainAddToCartButton, {
          attributes: true
        });

        // Initial sync
        if (this.mainAddToCartButton.hasAttribute('disabled')) {
          // Show the clickable div initially if disabled
          this.stickyAddToCartButton.setAttribute('disabled', '');
          this.stickyAddToCartButton.innerHTML = `
            <span class="button__label-options">SELECT OPTIONS</span>
            <span class="button__label-soldout" style="display: none;">SOLD OUT</span>
            <span class="price price--sale">
              <product-price class="empty-hide jsProductPrice">${this.mainAddToCartButton.querySelector('.jsProductPrice')?.innerHTML || ''}</product-price>
            </span>
          `;
          this.stickyAddToCartButton.classList.add('button--ternary');
          this.stickyAddToCartButton.classList.add('variant--disabled');
          
          // Show the clickable div initially if disabled
          this.clickableDiv.style.display = 'block';
        }

        // Handle click on sticky button
        this.stickyAddToCartButton.addEventListener('click', () => {
          if (!this.stickyAddToCartButton.hasAttribute('disabled')) {
            this.mainAddToCartButton.click();
          }
        });
      }

      set hidden(value) {
        this.toggleAttribute("hidden", value);
        if (value) {
          document.documentElement.style.removeProperty("--cart-notification-offset");
        } else {
          document.documentElement.style.setProperty("--cart-notification-offset", `${this.clientHeight}px`);
        }
      }

      _setupVisibilityObservers() {
        const productTitleElement = document.querySelector(".product-meta");
        const footerElement = document.querySelector(".shopify-section--footer");
        const mainProductForm = document.querySelector(".product-form__payment-container");
        const stickyHeaderOffset = getStickyHeaderOffset();

        this._isFooterVisible = this._isPricePassed = this._isMainFormVisible = false;

        this.intersectionObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === footerElement) {
              this._isFooterVisible = entry.intersectionRatio > 0;
            }
            if (entry.target === productTitleElement) {
              const boundingRect = productTitleElement.getBoundingClientRect();
              this._isPricePassed = entry.intersectionRatio === 0 && boundingRect.top + boundingRect.height <= stickyHeaderOffset;
            }
            if (entry.target === mainProductForm) {
              this._isMainFormVisible = entry.intersectionRatio > 0;
            }
          });

          if (window.matchMedia(window.themeVariables.breakpoints.pocket).matches) {
            // On mobile, hide if main form is visible or if price hasn't been passed
            this.hidden = !this._isPricePassed || this._isFooterVisible || this._isMainFormVisible;
          } else {
            // On desktop, only consider price passed and footer visibility
            this.hidden = !this._isPricePassed || this._isFooterVisible;
          }
        }, { rootMargin: `-${stickyHeaderOffset}px 0px 0px 0px` });

        if (productTitleElement) {
          this.intersectionObserver.observe(productTitleElement);
        }
        if (footerElement) {
          this.intersectionObserver.observe(footerElement);
        }
        if (mainProductForm) {
          this.intersectionObserver.observe(mainProductForm);
        }
      }
    }

    // Helper function to get sticky header offset
    function getStickyHeaderOffset() {
      const documentStyle = getComputedStyle(document.documentElement);
      return parseInt(documentStyle.getPropertyValue('--header-height') || 0);
    }

    customElements.define('product-sticky-form', ProductStickyForm);
  })(); 